import SEO from "../../../data/seo";
import BreadCrumb from "../../common/breadcrumb";
import HeaderTwo from "../../../layout/headers/header-two";
import PortfolioFilter from "./portfolio-filter";
import FooterTwo from "../../../layout/footers/footer-two";

const PortfolioFilterPage = () => {
    return (
        <>
            <SEO pageTitle="Gallery"
                keywords={[
                    "Construction Service",
                    "Construction industry news",
                    "Construction technology",
                    "construction management",
                    "star home",
                    "Construction project management Dhaka"
                ]} />
            <HeaderTwo />
            <BreadCrumb title="Gallery" innerTitle="Gallery" />
            <PortfolioFilter />
            <FooterTwo />
        </>
    );
};

export default PortfolioFilterPage;